module.exports = __webpack_public_path__ + "static/media/Raiden Shogun.fdcbc9ef.png";